import dynamic from 'next/dynamic';

const baseComponents = {
    ComponentNotFound: { dynamicComponent: dynamic(() => import(`components/base/ComponentNotFound/ComponentNotFound`)) }
};

export { baseComponents };
